import React from 'react'
import { Modal, modalVisibility, ModalVisibilityProps } from 'sb-modal'

import messages from './messages'


export const AlertModal: React.FunctionComponent<ModalVisibilityProps> = (props) => {
  const {
    iconName = 'happyBird',
    title,
    text,
    content,
    primaryButton,
    dataTestId = 'dialogModal',
    onClose,
    ...rest
  } = props

  return (
    <Modal
      iconName={iconName}
      title={title}
      text={text}
      content={content}
      primaryButton={{
        title: messages.buttonTitle,
        dataTestId: 'dialogModalButton',
        // we should pass onClose, to process onClose events
        onClick: onClose,
        ...primaryButton,
      }}
      dataTestId={dataTestId}
      onClose={onClose}
      {...rest}
    />
  )
}


export default modalVisibility('alert', AlertModal)
